export type SiteRoute = "home" | "about";

const PREVIEW_INDEX_HOST = "preview.perprotocol.org";

export function siteRoute(pathname: string): SiteRoute {
  return pathname === "/about" || pathname === "/about/" ? "about" : "home";
}

export function productUrlForHost(canonicalUrl: string, hostname: string) {
  if (hostname !== PREVIEW_INDEX_HOST) return canonicalUrl;

  const previewUrl = new URL(canonicalUrl);
  previewUrl.hostname = `preview.${previewUrl.hostname}`;
  return previewUrl.href.replace(/\/$/, "");
}
